import React from 'react';
import PropTypes from 'prop-types';
import { withI18n } from 'spa/Components/Context';

import TextareaInput from '@urbanmassage/component-library/lib/TextareaInput/TextareaInput';
import Typography, { TypeVariants } from '@urbanmassage/component-library/lib/Typography/Typography';

const GiftsMessage = ({giftMessage, onSetGiftMessage}, { i18n }) => {
  const handleGiftMessageChange = (e) => {
    const { value } = e.target;
    onSetGiftMessage(value);
  };

  const textAreaInputProps = {
    id: 'message',
    name: 'message',
    placeholder: i18n._x('Your gift message', 'Gifts page'),
    characterLimit: 2000,
    onChange: handleGiftMessageChange,
    value: giftMessage,
    style: {
      resize: 'vertical',
    },
  };


  return (
    <div className="gifts__message-wrapper">
      <Typography variant={TypeVariants.h3} className="gifts__type-selection-text">
        {i18n._x('Add a gift message (optional)', 'Gifts page')}
      </Typography>
      <TextareaInput {...textAreaInputProps} />
    </div>
  );
};

GiftsMessage.propTypes = {
  giftMessage: PropTypes.string,
  onSetGiftMessage: PropTypes.func.isRequired,
};

export default withI18n(GiftsMessage);



// WEBPACK FOOTER //
// ./spa/Pages/Gifts/GiftsMessageOld.jsx